import api from '../api/api';

export function CheckStock(productNumber, productId, quantity) {
  const checkStockUrl = `/web/services/product/getstock/${productNumber}/${productId}/${quantity}`;

  return api.get(checkStockUrl)
    .catch(exception => {
      const error = exception;
      error.statusText = `Call to checkStockUrl with ${checkStockUrl} failed. ${exception.statusText}`;
      return Promise.reject(error);
    });
}



// WEBPACK FOOTER //
// ./src/main/ui/react/shared/services/Stock/Stock.js